import React, { useState, useMemo } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';
import {
  FileText, Users, GraduationCap, BookOpen, UserCheck,
  Download, ExternalLink, FileSignature, Search,
  Copy, CheckCircle2, Filter, X, File,
  FileSpreadsheet, Loader2, ClipboardList, UserX,
  Calendar, AlertCircle, Settings
} from 'lucide-react';

const Students = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [copiedLink, setCopiedLink] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const base = 'https://dokumanhavuzu.hacettepe.edu.tr/kullanici/formlar/wordindir/';

  const categories = [
    {
      title: t('studentDocsCategories.category1.title'),
      icon: <Users className="w-5 h-5" />,
      color: 'blue',
      documents: [
        { title: t('studentDocsCategories.category1.doc1'),  link: base + '219' },
        { title: t('studentDocsCategories.category1.doc2'),  link: base + '220' },
        { title: t('studentDocsCategories.category1.doc3'),  link: base + '222' },
        { title: t('studentDocsCategories.category1.doc4'),  link: base + '240' },
        { title: t('studentDocsCategories.category1.doc5'),  link: base + '223' },
        { title: t('studentDocsCategories.category1.doc6'),  link: base + '224' },
        { title: t('studentDocsCategories.category1.doc7'),  link: base + '225' },
        { title: t('studentDocsCategories.category1.doc8'),  link: base + '250' },
        { title: t('studentDocsCategories.category1.doc9'),  link: base + '226' },
        { title: t('studentDocsCategories.category1.doc10'), link: base + '227' },
        { title: t('studentDocsCategories.category1.doc11'), link: base + '228' },
        { title: t('studentDocsCategories.category1.doc12'), link: base + '229' },
        { title: t('studentDocsCategories.category1.doc13'), link: base + '230' },
        { title: t('studentDocsCategories.category1.doc14'), link: base + '231' },
        { title: t('studentDocsCategories.category1.doc15'), link: base + '232' },
        { title: t('studentDocsCategories.category1.doc16'), link: base + '233' },
        { title: t('studentDocsCategories.category1.doc17'), link: base + '234' },
        { title: t('studentDocsCategories.category1.doc18'), link: base + '235' },
        { title: t('studentDocsCategories.category1.doc19'), link: base + '236' },
        { title: t('studentDocsCategories.category1.doc20'), link: base + '237' },
        { title: t('studentDocsCategories.category1.doc21'), link: base + '238' },
        { title: t('studentDocsCategories.category1.doc22'), link: base + '239' }
      ]
    },
    {
      title: t('studentDocsCategories.category2.title'),
      icon: <ClipboardList className="w-5 h-5" />,
      color: 'green',
      documents: [
        { title: t('studentDocsCategories.category2.doc1'),  link: base + '241' },
        { title: t('studentDocsCategories.category2.doc2'),  link: base + '251' },
        { title: t('studentDocsCategories.category2.doc3'),  link: base + '272' },
        { title: t('studentDocsCategories.category2.doc4'),  link: base + '242' },
        { title: t('studentDocsCategories.category2.doc5'),  link: base + '243' },
        { title: t('studentDocsCategories.category2.doc6'),  link: base + '244' },
        { title: t('studentDocsCategories.category2.doc7'),  link: base + '245' },
        { title: t('studentDocsCategories.category2.doc8'),  link: base + '250' },
        { title: t('studentDocsCategories.category2.doc9'),  link: base + '246' },
        { title: t('studentDocsCategories.category2.doc10'), link: base + '247' },
        { title: t('studentDocsCategories.category2.doc11'), link: base + '248' },
        { title: t('studentDocsCategories.category2.doc12'), link: base + '275' },
        { title: t('studentDocsCategories.category2.doc13'), link: base + '276' },
        { title: t('studentDocsCategories.category2.doc14'), link: base + '269' },
        { title: t('studentDocsCategories.category2.doc15'), link: base + '268' },
        { title: t('studentDocsCategories.category2.doc16'), link: base + '249' },
        { title: t('studentDocsCategories.category2.doc17'), link: base + '267' },
        { title: t('studentDocsCategories.category2.doc18'), link: base + '266' },
        { title: t('studentDocsCategories.category2.doc19'), link: base + '271' },
        { title: t('studentDocsCategories.category2.doc20'), link: base + '265' },
        { title: t('studentDocsCategories.category2.doc21'), link: base + '264' },
        { title: t('studentDocsCategories.category2.doc22'), link: base + '263' },
        { title: t('studentDocsCategories.category2.doc23'), link: base + '262' },
        { title: t('studentDocsCategories.category2.doc24'), link: base + '261' },
        { title: t('studentDocsCategories.category2.doc25'), link: base + '260' },
        { title: t('studentDocsCategories.category2.doc26'), link: base + '259' },
        { title: t('studentDocsCategories.category2.doc27'), link: base + '258' },
        { title: t('studentDocsCategories.category2.doc28'), link: base + '256' },
        { title: t('studentDocsCategories.category2.doc29'), link: base + '255' },
        { title: t('studentDocsCategories.category2.doc30'), link: base + '254' },
        { title: t('studentDocsCategories.category2.doc31'), link: base + '253' }
      ]
    },
    {
      title: t('studentDocsCategories.category3.title'),
      icon: <FileSpreadsheet className="w-5 h-5" />,
      color: 'amber',
      documents: [
        { title: t('studentDocsCategories.category3.doc1'), link: base + '333' },
        { title: t('studentDocsCategories.category3.doc2'), link: base + '337' },
        { title: t('studentDocsCategories.category3.doc3'), link: base + '335' }
      ]
    },
    {
      title: t('studentDocsCategories.category4.title'),
      icon: <GraduationCap className="w-5 h-5" />,
      color: 'purple',
      documents: [
        { title: t('studentDocsCategories.category4.doc1'), link: base + '210' },
        { title: t('studentDocsCategories.category4.doc2'), link: base + '216' },
        { title: t('studentDocsCategories.category4.doc3'), link: base + '217' },
        { title: t('studentDocsCategories.category4.doc4'), link: base + '250' },
        { title: t('studentDocsCategories.category4.doc5'), link: base + '249' }
      ]
    }
  ];

  const allCategories = categories;

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-gradient-to-r from-blue-600 to-blue-700 text-white',
      green: 'bg-gradient-to-r from-green-600 to-green-700 text-white',
      purple: 'bg-gradient-to-r from-purple-600 to-purple-700 text-white',
      indigo: 'bg-gradient-to-r from-indigo-600 to-indigo-700 text-white',
      rose: 'bg-gradient-to-r from-rose-600 to-rose-700 text-white',
      amber: 'bg-gradient-to-r from-amber-600 to-amber-700 text-white',
      cyan: 'bg-gradient-to-r from-cyan-600 to-cyan-700 text-white',
      emerald: 'bg-gradient-to-r from-emerald-600 to-emerald-700 text-white',
      slate: 'bg-gradient-to-r from-slate-600 to-slate-700 text-white'
    };
    return colorMap[color] || colorMap.blue;
  };

  const getFileIcon = (link) => {
    if (link.endsWith('.pdf')) return <FileText className="w-5 h-5 text-red-500" />;
    if (link.includes('wordindir') || link.endsWith('.doc') || link.endsWith('.docx')) return <FileText className="w-5 h-5 text-blue-500" />;
    if (link.endsWith('.xls') || link.endsWith('.xlsx')) return <FileSpreadsheet className="w-5 h-5 text-green-500" />;
    return <File className="w-5 h-5 text-gray-500" />;
  };

  const getFileType = (link) => {
    if (link.endsWith('.pdf')) return 'PDF';
    if (link.includes('wordindir') || link.endsWith('.doc') || link.endsWith('.docx')) return 'WORD';
    if (link.endsWith('.xls') || link.endsWith('.xlsx')) return 'EXCEL';
    return 'BELGE';
  };

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link);
    setCopiedLink(link);
    setTimeout(() => setCopiedLink(null), 2000);
  };

  const handleSearch = (value) => {
    setIsLoading(true);
    setSearchTerm(value);
    // Simulate loading state
    setTimeout(() => setIsLoading(false), 500);
  };

  const filteredCategories = useMemo(() => {
    const filtered = allCategories
      .map(category => ({
        ...category,
        documents: category.documents.filter(doc =>
          doc.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
      }))
      .filter(category => category.documents.length > 0);

    if (selectedCategory === 'all') return filtered;
    return filtered.filter(category => category.title === selectedCategory);
  }, [searchTerm, selectedCategory, allCategories]);

  const uniqueCategories = useMemo(() =>
    ['all', ...new Set(allCategories.map(cat => cat.title))],
    [allCategories]
  );

  const totalDocuments = useMemo(() =>
    filteredCategories.reduce((sum, cat) => sum + cat.documents.length, 0),
    [filteredCategories]
  );

  const DocumentCard = ({ document }) => {
    const fileIcon = getFileIcon(document.link);
    const fileType = getFileType(document.link);

    return (
      <div className="group relative">
        <a
          href={document.link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center p-4 hover:bg-gray-50 rounded-lg transition-all duration-200 border-l-4 border-l-transparent hover:border-l-blue-400 hover:shadow-sm cursor-pointer"
        >
          <div className="flex-shrink-0 mr-4">
            {fileIcon}
          </div>
          <div className="flex-grow min-w-0">
            <div className="flex items-start gap-3">
              <span className="text-base text-gray-700 group-hover:text-blue-600 leading-relaxed transition-colors">
                {document.title}
              </span>
              <span className="flex-shrink-0 px-2.5 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded-full group-hover:bg-blue-100 group-hover:text-blue-700 transition-colors">
                {fileType}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-2 ml-4">
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleCopyLink(document.link);
              }}
              className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-lg transition-colors group/button z-10 relative"
              title={t('studentDocuments.copyLink')}
            >
              {copiedLink === document.link ? (
                <CheckCircle2 className="w-5 h-5 text-green-500" />
              ) : (
                <Copy className="w-5 h-5 group-hover/button:scale-110 transition-transform" />
              )}
            </button>
            <div className="p-2 text-gray-400 group-hover:text-blue-500 transition-colors">
              <ExternalLink className="w-5 h-5 group-hover:scale-110 transition-transform" />
            </div>
          </div>
        </a>
      </div>
    );
  };

  return (
    <PageTemplate
      title={t('pages.documents.title')}
      subtitle={t('pages.documents.subtitle')}
    >
      <div className="max-w-[1400px] mx-auto px-4 py-8">
        {/* Başlık ve Açıklama */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl mb-6">
            <Users className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('studentDocuments.title')}</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('studentDocuments.description')}
          </p>
        </div>

        <div className="mb-8">
          {/* Arama ve Filtreleme */}
          <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center mb-8">
            <div className="relative flex-grow">
              <input
                type="text"
                placeholder={t('studentDocuments.searchPlaceholder')}
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                className="w-full px-6 py-4 pl-14 text-lg rounded-2xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 shadow-sm"
              />
              <div className="absolute left-5 top-1/2 transform -translate-y-1/2">
                {isLoading ? (
                  <Loader2 className="w-6 h-6 text-gray-400 animate-spin" />
                ) : (
                  <Search className="w-6 h-6 text-gray-400" />
                )}
              </div>
              {searchTerm && (
                <button
                  onClick={() => handleSearch('')}
                  className="absolute right-5 top-1/2 transform -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X className="w-5 h-5 text-gray-400" />
                </button>
              )}
            </div>

            <div className="relative group lg:min-w-[250px]">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full px-6 py-4 pr-12 text-base rounded-2xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 appearance-none bg-white shadow-sm"
              >
                <option value="all">{t('studentDocuments.allCategories')}</option>
                {uniqueCategories.slice(1).map((cat, idx) => (
                  <option key={idx} value={cat}>{cat}</option>
                ))}
              </select>
              <Filter className="w-5 h-5 text-gray-400 absolute right-5 top-1/2 transform -translate-y-1/2 pointer-events-none" />
            </div>
          </div>

          {/* Sonuç Özeti */}
          <div className="flex items-center justify-between text-sm text-gray-500 bg-gray-50 rounded-xl p-4">
            <div className="flex items-center gap-2">
              <AlertCircle className="w-4 h-4" />
              <span>
                <strong>{totalDocuments}</strong> {t('studentDocuments.documentsFound')}
                {searchTerm && ` "${searchTerm}" ${t('common.for')}`}
                {selectedCategory !== 'all' && ` ${selectedCategory} ${t('common.inCategory')}`}
              </span>
            </div>
            {(searchTerm || selectedCategory !== 'all') && (
              <button
                onClick={() => {
                  setSearchTerm('');
                  setSelectedCategory('all');
                }}
                className="text-blue-500 hover:text-blue-600 font-medium transition-colors"
              >
                {t('studentDocuments.clearFilters')}
              </button>
            )}
          </div>
        </div>

        {/* Kategoriler Grid */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
          {filteredCategories.map((category, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className={`px-8 py-6 flex items-center justify-between ${getColorClasses(category.color)}`}>
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-white/15 rounded-xl backdrop-blur-sm">
                    {React.cloneElement(category.icon, { className: "w-6 h-6" })}
                  </div>
                  <div>
                    <h3 className="font-bold text-lg tracking-tight">{category.title}</h3>
                    <p className="text-white/80 text-sm mt-1">
                      {t('studentDocuments.documentsForStudies')}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <span className="px-3 py-1.5 bg-white/20 rounded-full text-sm font-medium backdrop-blur-sm">
                    {category.documents.length}
                  </span>
                  <p className="text-white/80 text-xs mt-1">{t('studentDocuments.document')}</p>
                </div>
              </div>
              <div className="divide-y divide-gray-100">
                {category.documents.map((doc, docIndex) => (
                  <DocumentCard key={docIndex} document={doc} />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Boş Sonuç */}
        {filteredCategories.length === 0 && (
          <div className="text-center py-20 bg-white rounded-2xl shadow-lg border border-gray-100">
            <div className="text-gray-400 mb-6">
              <Search className="w-20 h-20 mx-auto" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">{t('studentDocuments.noResults')}</h3>
            <p className="text-gray-600 text-lg mb-6">
              {t('studentDocuments.noResultsDesc')}
            </p>
            <button
              onClick={() => {
                setSearchTerm('');
                setSelectedCategory('all');
              }}
              className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors font-medium"
            >
              {t('studentDocuments.showAll')}
            </button>
          </div>
        )}

        {/* Bilgilendirme */}
        <div className="mt-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <AlertCircle className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">{t('studentDocuments.importantInfo')}</h4>
              <p className="text-gray-700 leading-relaxed">
                {t('studentDocuments.infoText')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Students;
